import { render, staticRenderFns } from "./ZlifePetDemo.vue?vue&type=template&id=058c37d4&scoped=true"
import script from "./ZlifePetDemo.vue?vue&type=script&lang=js"
export * from "./ZlifePetDemo.vue?vue&type=script&lang=js"
import style0 from "./ZlifePetDemo.vue?vue&type=style&index=0&id=058c37d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058c37d4",
  null
  
)

export default component.exports